/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ViewViolationModel {
    getFixupPrototypeFunction() { return ViewViolationModel.fixupPrototype; }

    static newInstance(model: Partial<ViewViolationModel>): ViewViolationModel {
        let obj = Object.assign(new ViewViolationModel(), model);
        ViewViolationModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ViewViolationModel>): ViewViolationModel {
        if (!model) return null;
        return ViewViolationModel.newInstance(<ViewViolationModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ViewViolationModel) {
        if (!obj) return;

        models.ViewViolationModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ViewViolationModel): boolean {
        Object.setPrototypeOf(obj, ViewViolationModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
    }

    /**
     * Count of a particular violation in a particular cloud account
     */
    count: number;

    /**
     * Category under which a particular violation falls in a particular cloud account
     */
    category: string;

    /**
     * Tenant under which the cloud account resides
     */
    tenant_name: string;

    /**
     * Name of the violation
     */
    name: string;

    /**
     * ID of the cloud account
     */
    cloud_account_id: string;

    /**
     * Category of a violation i.e. standards/utilization
     */
    violation_category: string;

    /**
     * Cloud account name
     */
    cloud_account_name: string;

    /**
     * ID of the tenant
     */
    tenant_id: string;

    /**
     * Severity of the violation
     */
    severity: string;

}
